// frontend/src/app/claim-annotator/adapters/in-memory-pdf-source.ts
import { Injectable, Signal, signal } from '@angular/core';
import { PdfSource } from '../ports/pdf-source.port';

@Injectable({ providedIn: 'root' })
export class InMemoryPdfSource implements PdfSource {
  private readonly _current = signal<Blob | string | null>(null);
  private readonly _filename = signal<string | null>(null);
  readonly current: Signal<Blob | string | null> = this._current.asReadonly();
  readonly lastFilename: Signal<string | null> = this._filename.asReadonly();

  setBlob(blob: Blob, filename: string): void {
    this._current.set(blob);
    this._filename.set(filename);
  }

  setUrl(url: string): void {
    this._current.set(url);
    this._filename.set(null);
  }

  clear(): void {
    this._current.set(null);
    this._filename.set(null);
  }
}
